import script from "./MapsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MapsHeader.vue?vue&type=script&setup=true&lang=js"

import "./MapsHeader.vue?vue&type=style&index=0&id=4bfe38fa&lang=css"

const __exports__ = script;

export default __exports__